/**
 * @name v5Adapter
 * @type {function}
 * @inner
 * @param {Object} widgetInstance The Portal Widget Instance (a.k.a. `__WIDGET__`)
 * @return {WidgetAdapter} An adapter for a portal client v5 widget instance
 */
export const v5Adapter = (widgetInstance) => ({
  id: widgetInstance.id,
  getPreference: name => widgetInstance.getPreference(name),
  setPreference: (name, value) => widgetInstance.setPreference(name, value),
  saveModel: (f) => widgetInstance.model.save(f),
});

/**
 * @name v6Adapter
 * @type {function}
 * @inner
 * @param {Object} widgetInstance The Portal Widget Instance (a.k.a. `__WIDGET__`)
 * @return {WidgetAdapter} An adapter for a portal client v6 widget instance
 */
export const v6Adapter = (widgetInstance) => ({
  id: widgetInstance.id,
  getPreference: name => widgetInstance.preferences.getItem(name),
  setPreference: (name, value) => widgetInstance.preferences.setItem(name, value),
  saveModel: f => f(),
});

/**
 * @name adapter
 * @type {function}
 * @inner
 * @param {Object} widgetInstance The Portal Widget Instance (a.k.a. `__WIDGET__`)
 * @return {WidgetAdapter} An adapter for the detected portal client version
 */
export default (widgetInstance) =>
  (widgetInstance.preferences
   ? v6Adapter(widgetInstance)
   : v5Adapter(widgetInstance));

/**
 * @typedef WidgetAdapter
 * @type {Object}
 * @prop {string} id The widget instance's unique identifier
 * @prop {GetPreference} getPreference Get the named preference
 * @prop {SetPreference} setPreference Set the names preference to value
 * @prop {SaveModel} saveModel Persist the updated model preference values if required
 * @prop {string} contextRoot The root path of the current portal/experience context
 */

/**
 * @typedef GetPreference
 * @type {function}
 * @param {string} name The name of the preference to get
 * @return {string|undefined} The current value of the requested preference
 */

/**
 * @typedef SetPreference
 * @type {function}
 * @param {string} name The name of the preference to set
 * @param {any} value The value to set the current preference to
 * @return {any} The new value of the preference
 */

/**
 * @typedef SaveModel
 * @description Persist the updated model preference values if required
 * @type {function}
 * @param {function} callback The callback to be called once any preferences are persisted
 * @return {void}
 */



// WEBPACK FOOTER //
// ./lib-bb-widget/scripts/adapters.js